(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Scroll sticky header functionality
  document.addEventListener('DOMContentLoaded', function() {
    const scrollStickyHeader = document.querySelector('.scroll-sticky-header');
    const mainHeader = document.querySelector('.header-wrapper');
    let lastScrollTop = 0;
    let headerHeight = 0;

    if (scrollStickyHeader && mainHeader) {
      // Get header height after page load
      setTimeout(() => {
        headerHeight = mainHeader.offsetHeight;
      }, 100);

      function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // Show sticky header when scrolled past main header
        if (scrollTop > headerHeight) {
          scrollStickyHeader.style.display = 'block';
          scrollStickyHeader.classList.add('show');
        } else {
          scrollStickyHeader.classList.remove('show');
          // Hide after transition completes
          setTimeout(() => {
            if (!scrollStickyHeader.classList.contains('show')) {
              scrollStickyHeader.style.display = 'none';
            }
          }, 300);
        }
        
        lastScrollTop = scrollTop;
      }

      // Throttle scroll events for better performance
      let ticking = false;
      function requestTick() {
        if (!ticking) {
          requestAnimationFrame(handleScroll);
          ticking = true;
          setTimeout(() => { ticking = false; }, 16);
        }
      }

      window.addEventListener('scroll', requestTick);
      
      // Update cart count in sticky header when main cart updates
      const mainCartBubble = document.getElementById('cart-icon-bubble');
      const stickyCartBubble = document.getElementById('cart-icon-bubble-sticky');
      
      if (mainCartBubble && stickyCartBubble) {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
              // Sync cart count
              const mainCartCount = mainCartBubble.querySelector('.cart-count-bubble');
              const stickyCartCount = stickyCartBubble.querySelector('.cart-count-bubble');
              
              if (mainCartCount && stickyCartCount) {
                stickyCartCount.innerHTML = mainCartCount.innerHTML;
              } else if (mainCartCount && !stickyCartCount) {
                stickyCartBubble.appendChild(mainCartCount.cloneNode(true));
              } else if (!mainCartCount && stickyCartCount) {
                stickyCartCount.remove();
              }
              
              // Sync cart icon
              const mainCartIcon = mainCartBubble.querySelector('.svg-wrapper');
              const stickyCartIcon = stickyCartBubble.querySelector('.svg-wrapper');
              
              if (mainCartIcon && stickyCartIcon) {
                stickyCartIcon.innerHTML = mainCartIcon.innerHTML;
              }
            }
          });
        });
        
        observer.observe(mainCartBubble, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
